export default "__VITE_ASSET__993fae40__"